import { render, staticRenderFns } from "./BlockedList.vue?vue&type=template&id=3ab0eea4&scoped=true"
import script from "./BlockedList.vue?vue&type=script&lang=ts"
export * from "./BlockedList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab0eea4",
  null
  
)

export default component.exports